import React from 'react';
import { motion } from 'framer-motion';
import { 
  FaLaptopCode, 
  FaUserCog, 
  FaComments, 
  FaFlagCheckered, 
  FaChartBar,
  FaCog
} from 'react-icons/fa';
import './Workflow.scss';

const workflowSteps = [
  {
    id: 1,
    title: 'Подача заявки',
    description: 'Сотрудник пишет в общий WhatsApp или Telegram чат, как привык. Также заявку можно подать через Web-портал или Telegram-бот.',
    icon: FaLaptopCode,
    color: '#3b82f6'
  },
  {
    id: 2,
    title: 'Умная маршрутизация',
    description: 'Система автоматически определяет нужный отдел и назначает ответственное лицо. Участникам приходит мгновенное уведомление.',
    icon: FaUserCog,
    color: '#5cd5f6'
  },
  {
    id: 3,
    title: 'Промежуточные решения',
    description: 'В процессе работы специалист может оставлять комментарии, задавать вопросы и переводить статус.',
    icon: FaComments,
    color: '#f59e0b'
  },
  {
    id: 4,
    title: 'Закрытие заявки',
    description: 'Проблема решена. Заявитель получает уведомление о выполнении работы и акт (если требуется).',
    icon: FaFlagCheckered,
    color: '#10b981'
  },
  {
    id: 5,
    title: 'Сбор фидбека',
    description: 'Автоматический сбор оценки удовлетворенности (NPS). Данные попадают в аналитику для контроля качества.',
    icon: FaChartBar,
    color: '#ec4899'
  }
];

const Workflow: React.FC = () => {
  return (
    <section className="workflow section">
      <div className="container">
        <motion.div 
          className="section-heading"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <span className="section-badge">Как это работает</span>
          <div className="section-heading__title-wrapper">
            <div className="section-heading__icon">
              <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 12H11M11 7H15M11 17H15M11 7V17" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
                <rect x="2" y="9" width="6" height="6" rx="1.5" fill="currentColor"/>
                <rect x="15" y="4" width="6" height="6" rx="1.5" fill="currentColor"/>
                <rect x="15" y="14" width="6" height="6" rx="1.5" fill="currentColor"/>
              </svg>
            </div>
            <h2 className="section-heading__title">Логика работы</h2>
          </div>
          <p className="section-heading__subtitle">
            От создания заявки до аналитики — каждый шаг находится под вашим полным контролем.
          </p>
        </motion.div>

        <div className="workflow__path">
          {workflowSteps.map((step, index) => (
            <motion.div 
              className="workflow-step"
              key={step.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.15, duration: 0.6 }}
            >
              <div className="workflow-step__connector">
                <div 
                  className="step-icon-wrapper"
                  style={{ backgroundColor: `${step.color}15`, color: step.color }}
                >
                  {/* @ts-ignore */}
                  <step.icon className="step-icon" />
                </div>
                {index < workflowSteps.length - 1 && (
                  <div className="step-arrow">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <line x1="12" y1="5" x2="12" y2="19"></line>
                      <polyline points="19 12 12 19 5 12"></polyline>
                    </svg>
                  </div>
                )}
              </div>
              
              <div className="workflow-step__content">
                <div className="step-number">Шаг 0{step.id}</div>
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Workflow;
